
import { RoutePageType } from "@routes/interfaces"
import Notifications from "./pages/Notifications"

const notificationPages: RoutePageType[] = [
    {key: 'notification', element: Notifications}
]

export default notificationPages